import {Component, OnInit} from '@angular/core';
import {AlphaBatchEntityBaseComponent} from "../alpha-batch-entity-base.component";
import {NavigationItem} from "../../../../../../../core/shared/dto/navigation/navigation-item";


@Component({
    selector: 'alpha-batch-entity-side-component',
    templateUrl: 'alpha-batch-entity-side.component.html',
    styleUrls: ['alpha-batch-entity-side.component.scss'],
    standalone: false
})
export class AlphaBatchEntitySideComponent extends AlphaBatchEntityBaseComponent implements OnInit {

    navigationItems: NavigationItem[] = [
        {
            label: 'Informationen',
            action: 'alphaIntegrationInfo',
            tooltip: 'Informationen',
            icon: 'fa-solid fa-circle-info',
            toggleable: false,
            default: true
        },
        {
            label: 'Integration',
            action: 'alphaIntegration',
            tooltip: 'Integration',
            icon: 'fa-solid fa-layer-group',
            toggleable: false,
            default: false
        },
    ];


    ngOnInit() {
        super.ngOnInit();
    }



}
